
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonClosedRight as ObiThreewayAcuatorPistonClosedRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-closed-right.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonClosedRight = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-closed-right',
   elementClass: ObiThreewayAcuatorPistonClosedRightElement,
   events: {
     
   }
  });
 
 